module.exports = __webpack_public_path__ + "img/prontuario_op1.7ae78c59.svg";